export const ApiLoginEndpoints = {
  // Users
  decrypt: '/api/User/GetDecryptTokenApi'
};
